/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { GetSpinWheelBranchesAdminResponse } from '../models/GetSpinWheelBranchesAdminResponse';
import type { GetSpinWheelPrizesAdminResponse } from '../models/GetSpinWheelPrizesAdminResponse';
import type { GetSpinWheelRegionsAdminResponse } from '../models/GetSpinWheelRegionsAdminResponse';
import type { GetSpinWheelsResponseClient } from '../models/GetSpinWheelsResponseClient';
import type { GetSpinWheelUsersAdminResponse } from '../models/GetSpinWheelUsersAdminResponse';
import type { Pagination1OfSpinWheelListedAdminDto } from '../models/Pagination1OfSpinWheelListedAdminDto';
import type { PostSpinWheelAdminRequest } from '../models/PostSpinWheelAdminRequest';
import type { PutSpinWheelAdminRequest } from '../models/PutSpinWheelAdminRequest';
import type { PutSpinWheelBranchesAdminRequest } from '../models/PutSpinWheelBranchesAdminRequest';
import type { PutSpinWheelPrizesAdminRequest } from '../models/PutSpinWheelPrizesAdminRequest';
import type { PutSpinWheelRegionsAdminRequest } from '../models/PutSpinWheelRegionsAdminRequest';
import type { PutSpinWheelUsersAdminRequest } from '../models/PutSpinWheelUsersAdminRequest';
import type { SpinWheelAdminDto } from '../models/SpinWheelAdminDto';
import type { SpinWheelListedAdminDto } from '../models/SpinWheelListedAdminDto';
import type { UserPrizeClientDto } from '../models/UserPrizeClientDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class SpinWheelsService {
    /**
     * @returns GetSpinWheelsResponseClient OK
     * @throws ApiError
     */
    public static getSpinWheelsClient(): CancelablePromise<GetSpinWheelsResponseClient> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/client/v1/spinwheels',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * @returns UserPrizeClientDto OK
     * @throws ApiError
     */
    public static spinPrizeClient({
        id,
    }: {
        id: string,
    }): CancelablePromise<UserPrizeClientDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/client/v1/spinwheels/{id}/spin',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSpinWheels`
     * @returns Pagination1OfSpinWheelListedAdminDto OK
     * @throws ApiError
     */
    public static getPrizesAdmin({
        searchWord,
        validFrom,
        validTo,
        userId,
        isPrimary,
        page,
        limit,
        sortField,
        sortDescending,
    }: {
        searchWord?: string,
        validFrom?: string,
        validTo?: string,
        userId?: string,
        isPrimary?: boolean,
        page?: number,
        limit?: number,
        sortField?: string,
        sortDescending?: boolean,
    }): CancelablePromise<Pagination1OfSpinWheelListedAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/spinwheels',
            query: {
                'searchWord': searchWord,
                'validFrom': validFrom,
                'validTo': validTo,
                'userId': userId,
                'isPrimary': isPrimary,
                'page': page,
                'limit': limit,
                'sortField': sortField,
                'sortDescending': sortDescending,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageSpinWheel`
     * @returns SpinWheelListedAdminDto Created
     * @throws ApiError
     */
    public static createSpinWheelAdmin({
        requestBody,
    }: {
        requestBody?: PostSpinWheelAdminRequest,
    }): CancelablePromise<SpinWheelListedAdminDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/v1/spinwheels',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSpinWheelDetails`
     * @returns SpinWheelAdminDto OK
     * @throws ApiError
     */
    public static getSpinWheelByIdAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<SpinWheelAdminDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/spinwheels/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageSpinWheel`
     * @returns SpinWheelListedAdminDto OK
     * @throws ApiError
     */
    public static updateSpinWheelAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutSpinWheelAdminRequest,
    }): CancelablePromise<SpinWheelListedAdminDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/spinwheels/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `DeleteSpinWheel`
     * @returns void
     * @throws ApiError
     */
    public static deleteSpinWheelAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/admin/v1/spinwheels/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSpinWheelDetails`
     * @returns GetSpinWheelUsersAdminResponse OK
     * @throws ApiError
     */
    public static getSpinWheelUsersAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetSpinWheelUsersAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/spinwheels/{id}/users',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageSpinWheel`
     * @returns GetSpinWheelUsersAdminResponse OK
     * @throws ApiError
     */
    public static updateSpinWheelUsersAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutSpinWheelUsersAdminRequest,
    }): CancelablePromise<GetSpinWheelUsersAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/spinwheels/{id}/users',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSpinWheelDetails`
     * @returns GetSpinWheelPrizesAdminResponse OK
     * @throws ApiError
     */
    public static getSpinWheelPrizesAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetSpinWheelPrizesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/spinwheels/{id}/prizes',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageSpinWheel`
     * @returns GetSpinWheelPrizesAdminResponse OK
     * @throws ApiError
     */
    public static updateSpinWheelPrizesAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutSpinWheelPrizesAdminRequest,
    }): CancelablePromise<GetSpinWheelPrizesAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/spinwheels/{id}/prizes',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSpinWheelDetails`
     * @returns GetSpinWheelBranchesAdminResponse OK
     * @throws ApiError
     */
    public static getSpinWheelBranchesAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetSpinWheelBranchesAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/spinwheels/{id}/branches',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageSpinWheel`
     * @returns GetSpinWheelBranchesAdminResponse OK
     * @throws ApiError
     */
    public static putSpinWheelBranchesAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutSpinWheelBranchesAdminRequest,
    }): CancelablePromise<GetSpinWheelBranchesAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/spinwheels/{id}/branches',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ViewSpinWheelDetails`
     * @returns GetSpinWheelRegionsAdminResponse OK
     * @throws ApiError
     */
    public static getSpinWheelRegionsAdmin({
        id,
    }: {
        id: number,
    }): CancelablePromise<GetSpinWheelRegionsAdminResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/admin/v1/spinwheels/{id}/regions',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * **Required Policy:** `ManageSpinWheel`
     * @returns GetSpinWheelRegionsAdminResponse OK
     * @throws ApiError
     */
    public static putSpinWheelRegionsAdmin({
        id,
        requestBody,
    }: {
        id: number,
        requestBody?: PutSpinWheelRegionsAdminRequest,
    }): CancelablePromise<GetSpinWheelRegionsAdminResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/admin/v1/spinwheels/{id}/regions',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
